<template>
  <div class="overflow-hidden">
    <div class="min-h-screen">

      <!-- Hero Section -->
      <div class="relative h-screen min-h-[400px] max-h-[670px] sm:max-h-[800px] lg:max-h-[900px] xl:max-h-[1000px]">
        <div class="absolute inset-0 bg-black opacity-30"></div>
        <img src="../assets/Hanga-24/home/insta-1.jpg" alt="Background" class="h-full w-full object-cover">

        <NavBar class="absolute top-0 left-0 w-full" />

        <div
          class="font-futura absolute text-white text-md lg:text-7xl top-[300px] left-4 sm:left-8 md:left-12 lg:left-16 xl:left-20 xl:2/4 text-center sm:text-left"
          ref="text">
          <p v-for="(line, index) in baseText" :key="index"
            class="hero-text font-futura text-white text-5xl lg:text-7xl"
            :style="{ animationDelay: `${index * 0.8}s` }">
            {{ line }}
          </p>
        </div>
      </div>

      <!-- Welcome Section -->
      <div ref="observerElement">
        <div class="flex flex-col lg:flex-row mt-24 lg:mt-28 px-16 w-full lg:space-x-16">
          <!-- Text Section -->
          <transition appear name="fade-slide-up" v-if="isVisible">
            <div class="lg:text-left space-y-4 w-3/5">
              <p class="text-3xl lg:text-6xl font-futura text-navy">
                WELCOME TO NEW HANGA PITCHFEST
              </p>
            </div>
          </transition>

          <!-- Description Section -->
          <div class="text-justify mt-4 lg:mt-0 space-y-8 w-full lg:w-10/12">
            <transition name="fade-slide-right" appear v-if="isVisible">
              <p class="text-base lg:text-xl font-gramatika text-darkGray">
                Hanga Pitchfest is back and bigger than ever! Designed to catalyze Rwanda's most promising startups,
                this new model introduces a multi phase, performance driven program that nurtures early stage ventures,
                sharpens ecosystem collaboration, and positions Rwanda as a regional tech leader.
              </p>
            </transition>
          </div>
        </div>
      </div>

      <!-- What's New Section - Add these transitions -->
      <div
        class="flex flex-col lg:flex-row items-center justify-between px-6 py-12 lg:px-24 lg:py-20 gap-10 bg-white mt-8">
        <!-- Image Section -->
        <transition appear name="fade-slide-right">
          <div class="flex-1 w-full max-w-full lg:max-w-[50%]">
            <img src="../assets/contact.jpg" alt="What's New Image" class="w-full h-[300px] md:h-[60vh] object-cover">
          </div>
        </transition>

        <!-- Text Content -->
        <transition appear name="fade-slide-left">
          <div class="flex-1 w-full max-w-full lg:max-w-[50%]">
            <h2 class="text-3xl md:text-5xl font-futura text-navy mb-6"> WHAT'S NEW?</h2>

            <ul class="list-disc pl-6 space-y-5 text-xl text-darkGray font-gramatika">
              <transition-group name="fade-slide-up">
                <li v-for="(item, index) in [
                  'Structured Support Over 3 to 4 Months',
                  'Milestone Based Startup Progression',
                  'Deeper Ecosystem Collaboration',
                  'Investment & Partnership Readiness',
                  'Dedicated Track for Deep Tech Startups'
                ]" :key="index" :style="{ transitionDelay: `${index * 0.1 + 0.3}s` }">
                  {{ item }}
                </li>
              </transition-group>
            </ul>
          </div>
        </transition>
      </div>


      <!-- How It Works Section -->
      <div ref="observerElement1">
        <div v-if="isVisible1" class="relative w-full mt-8 md:mt-16 lg:mt-8 mb-3">
          <div class="absolute inset-0 bg-black opacity-20"></div>
          <img src="../assets/hybrid.jpg" alt="" class="w-full h-[350px] md:h-80 lg:h-[700px] object-cover">

          <div class="absolute inset-0 flex flex-col mt-32 justify-center px-4 md:px-8 lg:px-12">
            <Transition appear name="slide-left">
              <p class="font-futura text-white text-3xl md:text-4xl lg:text-7xl mb-4">
                HOW IT WORKS<br> (HYBRID APPLICATION)
              </p>
            </Transition>

            <div class="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-8">
              <Transition appear name="slide-left">
                <div class=" ml-8 w-full md:w-2/3 lg:w-3/4">
                  <li class="text-white font-gramatika text-xl">Public Call for Applications</li>
                  <li class="text-white font-gramatika text-xl ">Nominations by ESOs</li>
                </div>
              </Transition>

              <!-- <div class="w-full md:w-1/3 lg:w-1/4 flex justify-start md:justify-end">
                <Transition appear name="slide-right">
                  <router-link to="/about-us">
                    <button
                      class="font-gramatika text-white text-xl border rounded-full px-8 py-2 hover:bg-tangerine transition duration-300">
                      Learn More
                    </button>
                  </router-link>
                </Transition>
              </div> -->
            </div>
          </div>
        </div>
      </div>


      <!-- Journey Section -->
      <div ref="observerElement1">
        <transition name="fade-slide-right" appear v-if="isVisible1">
          <div class="container pt-16 md:pt-28 mx-auto px-4 lg:min-h-screen lg:py-48 lg:px-12 xl:max-w-none ">
            <p class="text-2xl md:text-6xl font-futura text-navy">THE JOURNEY: PHASE <br> BREAKDOWN</p>

            <div class="relative w-full pt-12 lg:pt-32">
              <div class="pointer-events-none absolute left-8 top-40 z-0 hidden w-full lg:block">
                <img src="../assets/Subtract.svg" class="w-full h-auto" alt="">
              </div>

              <div
                class="relative z-10 flex flex-col lg:flex-row lg:justify-between mb-20 space-y-16 lg:space-y-0 lg:space-x-8">
                <!-- Phase 1 -->
                <div class="w-full lg:w-1/3 space-y-4 relative pt-20">
                  <img src="../assets/one.svg" class="absolute top-0 left-0 h-16 w-16">
                  <p class="font-futura text-4xl text-navy">TOP 45 STARTUPS</p>
                  <p class="font-gramatika text-lg text-darkGray">
                    The program begins with an open
                    <span class="text-tangerine font-bold">call for applications</span>,
                    followed by
                    <span class="text-tangerine font-bold">selection of the top 45 startups and an intensive bootcamp</span>.
                    This phase helps teams sharpen their ideas, strengthen their pitch, and prepare for evaluation.
                  </p>
                </div>

                <!-- Phase 2 -->
                <div class="w-full lg:w-1/3 space-y-4 relative pt-20">
                  <img src="../assets/two.svg" class="absolute top-0 left-0 h-16 w-16">
                  <p class="font-futura text-4xl text-navy">TOP 25 STARTUPS</p>
                  <p class="font-gramatika text-lg text-darkGray">
                    The journey continues with the
                    <span class="text-tangerine font-bold">Top 25 Announcement</span>,
                    leading into a focused
                    <span class="text-tangerine font-bold">Top 25 Sprint</span>
                    where selected startups refine their business models, receive tailored support, and build stronger cases for growth.
                  </p>
                </div>

                <!-- Phases 3 & 4 -->
                <div class="w-full lg:w-1/3 space-y-24 lg:space-y-44">
                  <!-- Phase 3 -->
                  <div class="w-full space-y-4 relative pt-20">
                    <img src="../assets/three.svg" class="absolute top-0 left-0 h-16 w-16">
                    <div class="space-y-8">
                      <p class="font-futura text-4xl text-navy">TOP 10 STARTUPS</p>
                      <p class="font-gramatika text-lg text-darkGray">
                        The program advances with the
                        <span class="text-tangerine font-bold">Top 10 Final Sprint</span>,
                        where high-potential startups deepen their strategy, improve investor readiness, and prepare for the final stage.
                      </p>

                    </div>
                  </div>

                  <!-- Phase 4 -->
                  <div class="w-full space-y-4 relative pt-20 lg:pt-0">
                    <img src="../assets/four.svg"
                      class="absolute top-0 left-0 lg:-top-16 2xl:top-32 lg:left-12 h-16 w-16">
                    <div class="space-y-4 pt-8 lg:pt-8 2xl:pt-52">
                      <p class="font-futura text-4xl text-navy">FINAL PITCHING</p>
                      <p class="font-gramatika text-lg text-darkGray">
                        The journey concludes with the
                        <span class="text-tangerine font-bold">Top 5 Finalists Announcement</span>,
                        followed by the grand
                        <span class="text-tangerine font-bold">Final Pitching and Awarding Ceremony</span>
                        where finalists present their ventures and winners are recognized.
                      </p>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-- Core Feature Section -->
      <div class="relative mt-16 lg:mt-32 h-auto min-h-[600px]">
        <div class="mt-8 py-16 sm:mt-20 lg:mt-32 bg-cover h-full"
          :style="{ backgroundImage: `url(${require('@/assets/notched.svg')})` }">
          <div class="lg:text-left w-full lg:w-2/4 space-y-2 ml-4 lg:ml-8 mt-8 lg:mt-24">
            <p class="text-5xl lg:text-5xl font-futura text-white">CORE PROGRAM <br> FEATURES</p>
          </div>

          <div class="px-4 sm:px-6 md:px-8 lg:px-12 mt-8 md:mt-12 lg:mt-16 flex flex-col space-y-16 mb-16">
            <!-- First row -->
            <div class="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6">
              <div class="w-full md:w-1/3 space-y-4">
                <img src="../assets/website icons_high growth.svg" alt="" class="w-[50px] h-[50px]">
                <p class="text-xl lg:text-xl font-gramatika font-bold text-white">Defining High Growth</p>
                <p class="text-white font-gramatika">Startups are assessed by their:</p>
                <ul class="list-disc pl-6 space-y-2 text-sm text-white font-gramatika">
                  <li>Monthly revenue growth</li>
                  <li>Market size (TAM)</li>
                  <li>User traction</li>
                  <li>Clear competitive advantages</li>
                </ul>
              </div>
              <div class="w-full md:w-1/3 space-y-4">
                <img src="../assets/website icons_deep tech.svg" alt="" class="w-[50px] h-[50px]">
                <p class="text-xl lg:text-xl font-gramatika text-white font-bold"> Deep Tech Inclusion </p>
                <p class="text-white font-gramatika">Physical product and hardware startups <br> receive dedicated
                  support to address <br>
                  longer development cycles and resource <br> needs.</p>
              </div>
              <div class="w-full md:w-1/3 space-y-4">
                <img src="../assets/website icons_empowerment.svg" alt="" class="w-[70px] h-[70px]">
                <p class="text-xl lg:text-xl font-gramatika text-white font-bold">ESO Empowerment</p>
                <p class="text-white font-gramatika">Entrepreneur Support Organizations <br> (ESOs) play an active role:
                </p>
                <ul class="list-disc pl-6 space-y-2 text-sm text-white font-gramatika">
                  <li>Supporting applications</li>
                  <li>Helping startups hit milestones</li>
                  <li>Acting as accountability partners</li>
                  <li>Participating in dedicated training & <br> evaluation workshops</li>
                </ul>
              </div>
            </div>
            <!-- Second row -->
            <div class="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6">
              <div class="w-full md:w-1/3 space-y-4">
                <img src="../assets/website icons-07.svg" alt="" class="w-[50px] h-[50px]">
                <p class="text-xl lg:text-xl font-gramatika text-white font-bold">Real World Problem Solving</p>
                <p class="text-white font-gramatika">Private sector and cooperatives share real <br> industry
                  challenges. Startups respond with <br>
                  solutions that can be tested, validated, and <br> scaled with support from experts and <br>
                  researchers.</p>
              </div>
              <div class="w-full md:w-1/3 space-y-4">
                <img src="../assets/website icons_collaboration.svg" alt="" class="w-[50px]">
                <p class="text-xl lg:text-xl font-gramatika text-white font-bold">Ecosystem Collaboration</p>
                <p class="text-white font-gramatika">Hanga Pitchfest fosters connection and <br> shared growth through:
                </p>
                <ul class="list-disc pl-6 space-y-2 text-sm text-white font-gramatika">
                  <li>Investor roundtables</li>
                  <li>Corporate startup matchmaking</li>
                  <li>Ongoing dialogue between startups, <br> ESOs, corporates, and investors</li>
                </ul>
              </div>
              <div class="w-full md:w-1/3 space-y-4">
                <img src="../assets/website icons_visibility.svg" alt="" class="w-[50px]">
                <p class="text-xl lg:text-xl font-gramatika text-white font-bold">Visibility & Storytelling</p>
                <p class="text-white font-gramatika">Startups take on a marketing challenge to <br> boost storytelling
                  skills and brand clarity, which are essential <br> for winning investor and <br> partner confidence.</p>
              </div>

            </div>
          </div>


        </div>
      </div>


      <!-- Connect Section -->
      <div ref="observerElement3"
        class="flex flex-col lg:flex-row mt-48 lg:mt-48 space-y-8 lg:space-y-0 lg:space-x-16 px-6 lg:px-12 w-full mb-16">
        <!-- Text Section -->
        <div class="w-full lg:w-1/2 mt-16 lg:mt-16 2xl:mt-72">
          <transition name="fade-slide-up" appear v-if="isVisible3">
            <div class="space-y-2">
              <p class="text-3xl lg:text-6xl font-futura text-navy">READY TO TAKE OFF?</p>
            </div>
          </transition>

          <transition name="fade-slide-left" appear v-if="isVisible3">
            <div class="mt-8 text-justify space-y-12">
              <p class="text-navy font-gramatika text-lg lg:text-xl 2xl:text-2xl">
                Whether you're building a disruptive solution or scaling an early win, Hanga Pitchfest is your
                launchpad. With expert support,
                ecosystem collaboration, and real investor engagement, this is more than a pitch. It is a journey toward
                real growth. <br> <br> Let’s build the future, together.
              </p>
              <!-- Applications are closed for now. Re-enable this button next year:
                <button
                  class="mt-6 py-4 px-6 lg:px-8 font-gramatika bg-tangerine text-white font-semibold hover:bg-tangerine-dark transition-all"
                  ref="button">
                <a href="https://hanga.acceleratorapp.co/apply/program/hanga-pitchfest-2026" target="_blank">Apply Now</a>
                </button>
              -->
              

            </div>
          </transition>
        </div>

        <!-- Image Section -->
        <transition name="fade-slide-left" appear v-if="isVisible3">
          <div class="flex-1 relative h-[30px] sm:mt-10 md:h-auto md:mt-32 xl:mt-36 max-w-full md:max-w-[50%]">
            <img src="../assets/Hanga-24/home/insta-5.jpg" class="w-full h-full object-cover">
            <div class="absolute inset-0"
              style="background: linear-gradient(to bottom, rgba(1, 9, 48, 0.05) 0%, rgba(1, 9, 48, 0.2) 50%, rgba(1, 9, 48, 0.8) 100%);">
            </div>
          </div>
        </transition>
      </div>

      <scrollButton />
      <NewsLetter />
      <FooterPage />
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/Navbar.vue';
import FooterPage from '@/components/footerPage.vue';
import NewsLetter from '@/components/NewsLetter.vue';
import scrollButton from '@/components/scrollButton.vue';

export default {
  name: "PitchHanga",
  components: {
    NavBar,
    FooterPage,
    NewsLetter,
    scrollButton
  },

  data() {
    return {
      baseText: [
        'FROM A COMPETITION TO',
        'A GROWTH ENGINE FOR',
        'RWANDAN INNOVATION'
      ],
      isVisible: false,
      isVisible1: false,
      isVisible3: false,
    };
  },

  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slide-up-visible');
          entry.target.classList.add('zoom-in-visible');
          entry.target.classList.add('fade-in-visible');
        }
      })
    });

    const elements = this.$refs;
    for (let key in elements) {
      if (elements[key] && elements[key] instanceof Element) {
        observer.observe(elements[key]);
      }
    }

    this.initiativeAnimations();
    this.missoutAnimations();
    this.galleryAnimations();
  },

  methods: {
    initiativeAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      });

      if (this.$refs.observerElement) {
        observer.observe(this.$refs.observerElement);
      }
    },

    missoutAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible1 = true;
          }
        });
      });

      if (this.$refs.observerElement1) {
        observer.observe(this.$refs.observerElement1);
      }
    },

    galleryAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible3 = true;
          }
        });
      }, {
        threshold: 0.5
      });

      if (this.$refs.observerElement3) {
        observer.observe(this.$refs.observerElement3);
      }
    }
  }
}
</script>

<style>
.slide-up {
  transform: translateY(20px);
  opacity: 0;
  transition: all 2s ease-in-out;
}

.slide-up-visible {
  transform: translateY(0);
  opacity: 1;
}

.fade-in {
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
}

.fade-in-visible {
  opacity: 1;
}

.slide-up-enter-active,
.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.7s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(-50px);
}

.slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* General Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Fade and Slide Up */
.fade-slide-up-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* Fade and Slide Left */
.fade-slide-left-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-left-enter-from {
  opacity: 0;
  transform: translateX(-80px);
}

.fade-slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Fade and Slide Right */
.fade-slide-right-enter-active {
  transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-right-enter-from {
  opacity: 0;
  transform: translateX(80px);
}

.fade-slide-right-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Zoom In */
.zoom-enter-active {
  transition: all 0.7s ease;
}

.zoom-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.zoom-enter-to {
  opacity: 1;
  transform: scale(1);
}

.fade-slide-up-enter-active,
.fade-slide-up-leave-active {
  transition: opacity 1.1s ease-in-out, transform 1.1s ease-in-out;
}

.fade-slide-up-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-up-leave-to {
  opacity: 0;
  transform: translateY(80px);
}
</style>
